/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { authApi } from '../../../api/api'
import { STORAGE_KEYS, SUBSCRIPTION } from '../../../utils/consts'
import { ISaveUser } from '../../../utils/types'
import { isProfileData } from './user.functions'
import { IUser, IUserDetailsRes, UserState } from './user.types'
import store from '../../index'
import { signOut } from '../isAuth/isAuth'

const initialState = null as UserState

export const fetchUser = createAsyncThunk('user/fetchUser', async () => {
    return authApi
        .get<IUserDetailsRes>(
            `/api/users/detail/${localStorage.getItem(STORAGE_KEYS.ID)}`
        )
        .then((res) => {
            const { form, subscribed, ...data } = res.data
            return {
                ...data,
                subscribed,
                subscription: subscribed
                    ? SUBSCRIPTION.SOLO
                    : SUBSCRIPTION.FREE,
                projects: form,
                lastId: form.length ? form[form.length - 1].projectId : 0,
            }
        })
        .catch((err) => {
            // eslint-disable-next-line no-console
            if (
                err.response &&
                (err.response.status === 404 ||
                    err.response.status === 401 ||
                    err.response.status === 403)
            ) {
                // Clear storage and sign out
                localStorage.clear()
                store.dispatch(signOut())
                // Redirect to sign-in page
                window.location.href = '/sign-in'
            }

            throw err
        })
})

export const user = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (_state: any, action: PayloadAction<IUser>) => action.payload,
        updateUser: (state: any, action: PayloadAction<ISaveUser>) => {
            const data = action.payload
            if (isProfileData(data))
                return {
                    ...state,
                    ...data,
                    email: state?.email,
                    fullName: state.fullName,
                    subscription: data.subscribed
                        ? SUBSCRIPTION.SOLO
                        : SUBSCRIPTION.FREE,
                    logo: data.logo || state.logo,
                } as IUser
            return state
        },
        clearUser: () => null,
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUser.fulfilled, (_state, action) => action.payload)
    },
})

export const { setUser, updateUser, clearUser } = user.actions
export default user.reducer
